import { site, asyncFetchGet, asyncFetchDelete } from './global.js';


export async function postMaterial(name, description, classId, teacherId, attachment) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append("description", description);
    
    formData.append("belonged_class", classId);
    formData.append("teacher", teacherId);
    formData.append("attachment", attachment);
    const response = await fetch(site + "references/", {
        method: "POST",
        headers: {
            Authorization: "Token " + localStorage.getItem("token")
        },
        body: formData
    });
    const result = await response.json();
    return result;
}

export const getMaterialListByClass = (class_id) => asyncFetchGet('references', `/?belonged_class=${class_id}`)

export const deleteMaterialById = (material_id) => asyncFetchDelete('references', material_id)